import api from '../constants/api';
import { authHeader, checkToken } from '../helpers';

export const postApi = async (data) => {

    let response = await fetch(api.url, {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    });

    let json = await response.json();

    console.log("http-response:", json);

    const refreshed = await checkToken(json);

    if (refreshed) {

        response = await fetch(api.url, {
            method: 'POST',
            headers: authHeader(),
            body: JSON.stringify(data),
        });

        json = await response.json();
    }

    return json;
};